// extracted by mini-css-extract-plugin
export default {"tasks":"OQ-z","task":"PQ-z","svg":"QQ-z","text":"RQ-z"};